import { delay } from './delay'

export const rateLimit = async <Fn extends (...args: any[]) => Promise<any>>(
  limit: number,
  fn: Fn,
  ...args: Parameters<Fn>
): Promise<ReturnType<Fn>> => {
  const start = Date.now()
  const result = await fn(...args)

  const left = limit - (Date.now() - start)
  if (left > 0) {
    await delay(left)
    await new Promise(resolve => setTimeout(resolve, limit - (Date.now() - start)))
  }

  return result
}
